import React, { createContext, useContext, useState } from 'react';

interface VolumeContextType {
    volume: number;
    setVolume: (vol: number) => void;
}

const VolumeContext = createContext<VolumeContextType>({
    volume: 0.5,
    setVolume: () => {},
});

export const VolumeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [volume, setVolumeState] = useState<number>(() => {
        const saved = localStorage.getItem('volume');
        return saved !== null ? parseFloat(saved) : 0.5;
    });

    const setVolume = (vol: number) => {
        setVolumeState(vol);
        localStorage.setItem('volume', vol.toString());
    };

    return (
        <VolumeContext.Provider value={{ volume, setVolume }}>
            {children}
        </VolumeContext.Provider>
    );
};

export const useVolume = () => useContext(VolumeContext);

export default VolumeContext;
